export const DISPLAY_MODES = {
  PLACEMENT_ONLY: 'placementOnly',
  NONE: 'none',
  NAME: 'name',
  NAME_AND_COUNT: 'nameAndCount',
  HEAT: 'heat',
  COMPARISON_HEAT: 'comparisonHeat',
};
